<template>
  <header class="gridx">
    <vs-navbar
      v-model="indexActive"
      :color="topbarColor"
      class="topnavbar"
      text-color="rgba(255,255,255,0.7)"
      active-text-color="rgba(255,255,255,1)"
    >
      <!---
      Template logo
      -->
      <div slot="title" class="themelogo">
        <img :src="logo" v-if="logo" alt="Dashboard" />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div>
      <!---
      Mobile toggle
      -->
      <div slot="title">
        <div
          class="hiddenDesktop cursor-pointer mr-2"
          @click.stop="activeSidebar"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ffffff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </div>
      </div>
      <!---
      Craete new dd
      -->
      <!-- <vs-button class="mx-2" color="dark" href="/" type="filled"
        >Upgrade Account</vs-button
      > -->

      <vs-spacer></vs-spacer>

      <!---
      Craete new dd
      -->
      <vs-dropdown
        vs-trigger-click
        left
        class="cursor-pointer pr-2 pl-2 ml-1 mr-md-3"
      >
        <a class="text-white-dark user-image" href="#"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABh0lEQVRIS7VVIUwDQRCc0Xg8eDR4sAQLWNAUDRp0wQK2YAFLNa3Gt74evWTIXnN/f/efa/KbNE0+ezu7s7uzxMDGgeOjF8DMDgDotwNg1xNaAFgC+CY570qyCGBmewCuAWz3VLkCMCb5k/PLApjZOYCzSvqeSH6kb1oAZnYC4LIyeHB/Jvkev20AOC33GwYPz25iulKAlwLnvwBeAXx5lCOncCuTzIrkRfi+BvBpuS1k3yq9h8o7kjPFigE0MYcFgFOSqmJtZqbs3wr+U5LjFODRZz33phZgQXKUAnx2NLeWIpA8rgEQPRMAU09CVGpXck3+d8kBdFFUO7lLklc1TZYcSAr0L5N8SEpKMpJtsgQtHVNRo5HL6owvpt6kVLXHVGmZWbpoI5JSzqKZmRT2IXLIL5oDqOxYKtRUiVhjB0Iw3wXtj6oPVpYKB0nFTsElYPNQjWe9D0C+MT3dYhdltomitoI3pigledCDE4NFJ1PN1NmU6Vyq+bMgaqUp6L3JtRuW+g8O8AepJ50ZCnDLFAAAAABJRU5ErkJggg=="
        /></a>
        <vs-dropdown-menu class="topbar-dd">
          <vs-dropdown-item
            ><vs-icon icon="person_outline" class="mr-1"></vs-icon> My
            Profile</vs-dropdown-item
          >
          <vs-dropdown-item
            ><vs-icon icon="sentiment_very_satisfied" class="mr-1"></vs-icon> My
            Balance</vs-dropdown-item
          >
          <vs-dropdown-item
            ><vs-icon icon="mail_outline" class="mr-1"></vs-icon>
            Inbox</vs-dropdown-item
          >
          <hr class="mb-1" />
          <vs-dropdown-item @click="logout()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-logout"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="#2c3e50"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <path
                d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
              />
              <path d="M7 12h14l-3 -3m0 6l3 -3" />
            </svg>
            Logout
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-navbar>
  </header>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    topbarColor: {
      type: String,
      default: "#2962ff"
    },
    title: {
      type: String
    },
    logo: {
      type: String
    }
  },
  data: () => ({
    indexActive: 0,
    showToggle: false
  }),

  methods: {
    //This is for sidebar trigger in mobile
    activeSidebar() {
      this.$store.commit("IS_SIDEBAR_ACTIVE", true);
    },
    logout() {
      this.$store.dispatch("account/logout");
    }
  }
};
</script>
